/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack, Divider } from '@mui/material';
// mock
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { fr } from 'date-fns/locale';
import { format } from 'date-fns';
import account from '../../_mock/account';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
//
import navConfig from './NavConfig';
import Iconify from '../../components/Iconify';
import navConfigMetrics from '../metrics/navConfigMetrics';
import NavSectionMetrics from '../../components/navSectionMetrics';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 260;
const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

// ----------------------------------------------------------------------

DashboardMetricsSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};


export default function DashboardMetricsSidebar({ isOpenSidebar, onCloseSidebar }) {
  const isDesktop = useResponsive('up', 'lg');
  

  const content = (
    <Scrollbar>
      <Box px={2} py={2}>
        <Typography variant="h5" fontWeight="bold">
          Analytics
        </Typography>
      </Box>

      <Divider />

      <NavSectionMetrics navConfig={navConfigMetrics} onCloseSidebar={onCloseSidebar} isDesktop={isDesktop} />
      <Box flexGrow={1} />
    </Scrollbar>
  );

  return (
    <RootStyle>
      <Drawer
        open={isDesktop || isOpenSidebar}
        onClose={onCloseSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
        PaperProps={{
          sx: {
            width: DRAWER_WIDTH,
            borderRight: '1px solid #eee',
          },
        }}
      >
        {content}
      </Drawer>
    </RootStyle>

  );
}

